import { Box, Button, Grid, Stack } from "@mui/material";
import stylesAnalytics from "../../styles/pages/analytics.module.scss";
import styles from "../../styles/pages/analyticseditor.module.scss";
import styles1 from "../../styles/pages/notification.module.scss";
import styles2 from "../../styles/pages/home.module.scss";
import React, { useCallback, useRef, useState } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import assest from "../../json/assest";
import {
  customSubmissionsList,
  submissionsList,
} from "../../api/functions/cms.api";
import { useQuery } from "react-query";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Wrapper from "../../layout/wrapper/Wrapper";
import { Link } from "react-router-dom";
import NotificationLeftFilter from "../../components/NotificationLeftFilter/NotificationLeftFilter";
import AnalyticPageBreakdownTable from "../../components/AnalyticPageBreakdownTable/AnalyticPageBreakdownTable";
import VideosBaseModalTable from "../../components/ModalTables/Videos/VideosBaseModalTable";
import SubmissionModal from "../../components/ModalTables/Submissions/SubmissionModal";
import ExpensesModal from "../../components/ModalTables/Expenses/ExpensesModal";
import ConfirmedVideos from "./components/ConfirmedVideos";
import DeniedVideos from "./components/DeniedVideos";
import CompletedVideos from "./components/CompletedVideos";
import AllSubmissions from "./components/AllSubmissions";
import TopAcquisitors from "./components/TopAcquisitors";
import DashboardApproveApproveModal from "../../components/ModalTables/Videos/DashboardApproveApproveModal";
import DashboardRejectedRejectedModal from "../../components/ModalTables/Videos/DashboardRejectedRejectedModal";
import DashboardWebsiteWebsiteModal from "../../components/ModalTables/Videos/DashboardWebsiteWebsiteModal";
import DashboardApproveRejectedModal from "../../components/ModalTables/Videos/DashboardApproveRejectedModal";
import DashboardApproveWebsiteModal from "../../components/ModalTables/Videos/DashboardApproveWebsiteModal";
import DashboardRejectedApprovedModal from "../../components/ModalTables/Videos/DashboardRejectedApprovedModal";
import DashboardRejectedWebsiteModal from "../../components/ModalTables/Videos/DashboardRejectedWebsiteModal";
import DashboardWebsiteApprovedModal from "../../components/ModalTables/Videos/DashboardWebsiteApprovedModal";
import DashboardWebsiteRejectedModal from "../../components/ModalTables/Videos/DashboardWebsiteRejectedModal";
import ApiLoader from "../../components/Loaders/ApiLoader";
import DashboardUnreachableModal from "../../components/ModalTables/Videos/DashboardUnreachableModal";

const Analytics = () => {
  const [loading, setLoading] = useState(false);
  const selectedYearMonth = useRef({ year: "", month: "", monthName: "" });

  const [openRejectedModal, setOpenRejectedModal] = useState(false);
  const handleOpenRejectedModal = useCallback(() => {
    setOpenRejectedModal(true);
  }, []);
  const handleCloseRejectedModal = useCallback(() => {
    setOpenRejectedModal(false);
  }, []);

  /********************************/

  const [openApprovedModal, setOpenApprovedModal] = useState(false);
  const handleOpenApprovedModal = useCallback(() => {
    setOpenApprovedModal(true);
  }, []);
  const handleCloseApprovedModal = useCallback(() => {
    setOpenApprovedModal(false);
  }, []);

  /*************************************/

  const [openWebsiteModal, setOpenWebsiteModal] = useState(false);
  const handleOpenWebsiteModal = useCallback(() => {
    setOpenWebsiteModal(true);
  }, []);
  const handleCloseWebsiteModal = useCallback(() => {
    setOpenWebsiteModal(false);
  }, []);

  /*************************************/

  const [openApproveRejectModal, setOpenApproveRejectModal] = useState(false);
  const handleOpenApproveRejectModal = useCallback(() => {
    setOpenApproveRejectModal(true);
  }, []);
  const handleCloseApproveRejectModal = useCallback(() => {
    setOpenApproveRejectModal(false);
  }, []);

  /**************************************/

  const [openApproveWebsiteOnlyModal, setOpenApproveWebsiteOnlyModal] =
    useState(false);
  const handleOpenApproveWebsiteOnlyModal = useCallback(() => {
    setOpenApproveWebsiteOnlyModal(true);
  }, []);
  const handleCloseApproveWebsiteOnlyModal = useCallback(() => {
    setOpenApproveWebsiteOnlyModal(false);
  }, []);

  /**********************************/

  const [openRejectedApproveModal, setOpenRejectedApproveModal] =
    useState(false);
  const handleOpenRejectedApproveModal = useCallback(() => {
    setOpenRejectedApproveModal(true);
  }, []);
  const handleCloseRejectedApproveModal = useCallback(() => {
    setOpenRejectedApproveModal(false);
  }, []);

  /************************************/

  const [openRejectedWebModal, setOpenRejectedWebModal] = useState(false);
  const handleOpenRejectedWebModal = useCallback(() => {
    setOpenRejectedWebModal(true);
  }, []);
  const handleCloseRejectedWebModal = useCallback(() => {
    setOpenRejectedWebModal(false);
  }, []);

  /***********************************/

  const [openWebApprovedModal, setOpenWebApprovedModal] = useState(false);
  const handleOpenWebApprovedModal = useCallback(() => {
    setOpenWebApprovedModal(true);
  }, []);
  const handleCloseWebApprovedModal = useCallback(() => {
    setOpenWebApprovedModal(false);
  }, []);

  /*********************************/

  const [openWebRejectedModal, setOpenWebRejectedModal] = useState(false);
  const handleOpenWebRejectedModal = useCallback(() => {
    setOpenWebRejectedModal(true);
  }, []);
  const handleCloseWebRejectedModal = useCallback(() => {
    setOpenWebRejectedModal(false);
  }, []);

  /******************************/

  const [openSubmissionModal, setOpenSubmissionModal] = useState(false);
  const handleOpenSubmissionModal = useCallback(() => {
    setOpenSubmissionModal(true);
  }, []);
  const handleCloseSubmissionModal = useCallback(() => {
    setOpenSubmissionModal(false);
  }, []);

  /**************expense modal states************/

  const [openExpensesModal, setOpenExpensesModal] = useState(false);
  const handleOpenExpensesModal = useCallback(() => {
    setOpenExpensesModal(true);
  }, []);
  const handleCloseExpensesModal = useCallback(() => {
    // selectedYearMonth.current = { year: "", month: "", monthName: "" };
    setOpenExpensesModal(false);
  }, []);

  /********************************/

  const [openTopApproved, setOpenTopApproved] = React.useState(false);
  const handleToggleTopApproved = () => {
    setOpenTopApproved(!openTopApproved);
  };

  const [filterDate, setFilterDate] = useState("");
  const getDataFromChild = useCallback(
    (date) => {
      setFilterDate(date);
    },
    [filterDate]
  );

  const { data: submission, isLoading } = useQuery(
    ["customSubmissionsList", filterDate],
    (body) => customSubmissionsList(body, filterDate)
  );
  const isApiCalledSuccessfully = useCallback(
    (data) => {
      console.warn("isApiCalledSuccessfully", data);
      setLoading(data);
    },
    [loading]
  );

  const [dataFromChild, setDataFromChild] = useState("");

  // Function to receive data from the child component
  const receiveDataFromChild = (data) => {
    setDataFromChild(data);
  };

  return (
    <Wrapper>
      {/* <Seo title="Analytics" canonical={''} description={''} url={''} image={''} /> */}
      {loading && isLoading ? (
        <ApiLoader loading={isLoading && loading} />
      ) : (
        <Box
          className={`${styles.bodyWrap} ${styles.bodyWrapanalytics} main_body`}
        >
          <Box className={stylesAnalytics.analyticWrapper}>
            <Box className={stylesAnalytics.scrollBar}>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Box
                  className={`${styles.SecFilter} ${styles1.SecFilterAnalytics}`}
                >
                  <NotificationLeftFilter
                    filterType={"for_partners"}
                    getDataFromChild={getDataFromChild}
                  />
                </Box>

                <Box className={`${styles.analyticBody}`}>
                  <Stack direction={"row"} className={styles.analyticStack}>
                    {/* CONFIRMED VIDEOS */}
                    <ConfirmedVideos
                      data={submission?.data}
                      handleOpenApprovedModal={handleOpenApprovedModal}
                      handleOpenRejectedModal={handleOpenRejectedModal}
                      handleOpenWebsiteModal={handleOpenWebsiteModal}
                    />
                    {/* DENIED VIDEOS */}
                    <DeniedVideos
                      data={submission?.data}
                      handleOpenApproveRejectModal={
                        handleOpenApproveRejectModal
                      }
                      handleOpenApproveWebsiteOnlyModal={
                        handleOpenApproveWebsiteOnlyModal
                      }
                      handleOpenRejectedApproveModal={
                        handleOpenRejectedApproveModal
                      }
                      handleOpenRejectedWebModal={handleOpenRejectedWebModal}
                      handleOpenWebApprovedModal={handleOpenWebApprovedModal}
                      handleOpenWebRejectedModal={handleOpenWebRejectedModal}
                    />
                    {/* COMPLETED VIDEOS */}
                    <CompletedVideos
                      data={submission?.data?.video_publishing ?? {}}
                    />
                  </Stack>

                  <Stack
                    direction={"row"}
                    className={
                      dataFromChild === true
                        ? ` ${styles.analyticStack}  ${styles.analyticStackNewOne}  `
                        : styles.analyticStack
                    }
                  >
                    {/* ALL SUBMISSIONS */}
                    <AllSubmissions
                      data={submission?.data}
                      handleOpenSubmissionModal={handleOpenSubmissionModal}
                    />
                    {/* TOP ACQUISITORS */}
                    <TopAcquisitors
                      sendDataToParent={receiveDataFromChild}
                      filterDate={filterDate}
                      handleToggleTopApproved={handleToggleTopApproved}
                      openTopApproved={openTopApproved}
                      isApiCalledSuccessfully={isApiCalledSuccessfully}
                    />
                  </Stack>
                </Box>
              </Stack>

              <Box className={styles.analyticsBreakdown}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box className={styles2.commonSmallBoxWrapper}>
                      <Box className="commonSmallBoxPartner analyticbreakdown">
                        <AnalyticPageBreakdownTable
                          handleOpenExpensesModal={handleOpenExpensesModal}
                          selectedYearMonth={selectedYearMonth}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>

          {/* <---------------------------- MODAL SECTIONS ----------------------------> */}

          {/* <SubmissionModal
            open={openSubmissionModal}
            onClose={handleCloseSubmissionModal}
          /> */}
          <DashboardUnreachableModal
            headerTitle="Un videos"
            open={openSubmissionModal}
            enable={openSubmissionModal}
            onClose={handleCloseSubmissionModal}
          />

          <ExpensesModal
            open={openExpensesModal}
            onClose={handleCloseExpensesModal}
            selectedYearMonth={selectedYearMonth.current}
          />

          <DashboardApproveApproveModal
            open={openApprovedModal}
            enable={openApprovedModal}
            modalHeaderProps={{
              fromStatus: "Approved",
              toStatus: "Approved",
            }}
            tableDataProps={{
              approvedByColName: "Approved by",
              confirmedByColName: "Confirmed by",
            }}
            onClose={handleCloseApprovedModal}
          />

          <DashboardRejectedRejectedModal
            open={openRejectedModal}
            enable={openRejectedModal}
            modalHeaderProps={{
              fromStatus: "Rejected",
              toStatus: "Rejected",
            }}
            tableDataProps={{
              approvedByColName: "Rejected by",
              confirmedByColName: "Confirmed by",
            }}
            onClose={handleCloseRejectedModal}
          />

          <DashboardWebsiteWebsiteModal
            open={openWebsiteModal}
            enable={openWebsiteModal}
            modalHeaderProps={{
              fromStatus: "Website only",
              toStatus: "Website only",
            }}
            tableDataProps={{
              approvedByColName: "Marked by",
              confirmedByColName: "Confirmed by",
            }}
            onClose={handleCloseWebsiteModal}
          />

          <DashboardApproveRejectedModal
            open={openApproveRejectModal}
            enable={openApproveRejectModal}
            modalHeaderProps={{
              fromStatus: "Approved",
              toStatus: "Rejected",
            }}
            tableDataProps={{
              approvedByColName: "Approved by",
              confirmedByColName: "Rejected by",
            }}
            onClose={handleCloseApproveRejectModal}
          />

          <DashboardApproveWebsiteModal
            open={openApproveWebsiteOnlyModal}
            enable={openApproveWebsiteOnlyModal}
            modalHeaderProps={{
              fromStatus: "Approved",
              toStatus: "Website only",
            }}
            tableDataProps={{
              approvedByColName: "Approved by",
              confirmedByColName: "Marked by",
            }}
            onClose={handleCloseApproveWebsiteOnlyModal}
          />

          <DashboardRejectedApprovedModal
            open={openRejectedApproveModal}
            enable={openRejectedApproveModal}
            modalHeaderProps={{
              fromStatus: "Rejected",
              toStatus: "Approved",
            }}
            tableDataProps={{
              approvedByColName: "Rejected by",
              confirmedByColName: "Approved by",
            }}
            onClose={handleCloseRejectedApproveModal}
          />

          <DashboardRejectedWebsiteModal
            open={openRejectedWebModal}
            enable={openRejectedWebModal}
            modalHeaderProps={{
              fromStatus: "Rejected",
              toStatus: "Website Only",
            }}
            tableDataProps={{
              approvedByColName: "Rejected by",
              confirmedByColName: "Marked by",
            }}
            onClose={handleCloseRejectedWebModal}
          />

          <DashboardWebsiteApprovedModal
            open={openWebApprovedModal}
            enable={openWebApprovedModal}
            modalHeaderProps={{
              fromStatus: "Website Only",
              toStatus: "Approved",
            }}
            tableDataProps={{
              approvedByColName: "Marked by",
              confirmedByColName: "Approved by",
            }}
            onClose={handleCloseWebApprovedModal}
          />

          <DashboardWebsiteRejectedModal
            open={openWebRejectedModal}
            enable={openWebRejectedModal}
            modalHeaderProps={{
              fromStatus: "Website Only",
              toStatus: "Rejected",
            }}
            tableDataProps={{
              approvedByColName: "Marked by",
              confirmedByColName: "Rejected by",
            }}
            onClose={handleCloseWebRejectedModal}
          />
        </Box>
      )}
    </Wrapper>
  );
};

export default Analytics;
